import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'shared-quantity',
    templateUrl: './quantity.shared.component.html',
    styleUrls: ['./quantity.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuantityComponent implements OnInit, OnChanges {
    public showDecrementButton: boolean = true;
    public showRemoveButton: boolean = false;
    public isDecrementButtonDisabled: boolean = false;
    public isIncrementButtonDisabled: boolean = false;
    public maskDecrementButtons: boolean = false;

    public btnNegativeFeel: OLO.Components.BUTTON_CIRCLE_FEEL = 'negative-secondary';
    public btnPostiveFeel: OLO.Components.BUTTON_CIRCLE_FEEL = 'positive-secondary';
    /*
        Mode 'normal'
        Large buttons - used inside wizzard counter

        Mode 'compact'
        Medium buttons, buttons with transparent background - used for modal counter

        Mode 'mini'
        Used for wizzard and cart items - similar to normal, but smaller
    */
    @Input() public mode: OLO.Components.Quantity.QUANTITY_MODE = 'mini';
    @Input() public max: number = 9999;
    @Input() public quantity: number;
    @Input() public remove: boolean = false; /* Show remove when quantity equals 1 */
    @Input() public minimumHide: boolean = false; /* Hide decrement / remove button when quantity equals 1 */
    @Input() public size: OLO.Components.BUTTON_SIZE;
    @Input() public disabled: boolean = false;
    @Input() public canDecrement: boolean = true; /* Can override components calculations */
    @Input() public canIncrement: boolean = true; /* Can override components calculations */

    @Output() public onDecrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onIncrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onRemove: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
        this.setButtonsFeel();
        this.updateFlags();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateFlags();
    }

    public setButtonsFeel(): void {
        /* Set buttons feel */
        switch (this.mode) {
            case 'compact':
                this.btnNegativeFeel = 'negative';
                this.btnPostiveFeel = 'positive';
                break;

            case 'normal':
                this.btnNegativeFeel = 'negative-outlined';
                this.btnPostiveFeel = 'positive-tiertary';
                break;

            case 'mini':
            default:
            /* Do nothing - defaults */
        }
    }

    public updateFlags(): void {
        this.showRemoveButton = this.remove === true && this.quantity === 1;
        this.showDecrementButton = this.remove === true && this.quantity > 1 || this.remove === false;

        this.isDecrementButtonDisabled = this.quantity <= 1 && !this.disabled || this.canDecrement === false;
        this.isIncrementButtonDisabled = this.quantity === this.max && !this.disabled || this.canIncrement === false;

        this.maskDecrementButtons = this.minimumHide && this.quantity <= 1 || this.minimumHide && isNaN(this.quantity);
    }

    public handleIncrement($event: Event): void {
        this.onIncrement.emit({
            event: $event,
            previousValue: this.quantity,
            nextValue: this.quantity + 1,
        });
    }

    public handleDecrement($event: Event): void {
        this.onDecrement.emit({
            event: $event,
            previousValue: this.quantity,
            nextValue: this.quantity - 1,
        });
    }

    public handleRemove($event: Event): void {
        this.onRemove.emit({
            event: $event,
            previousValue: this.quantity,
            nextValue: 0,
        });
    }
}
